/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  PluginAudience,
  PluginAudience$inboundSchema,
} from "./pluginaudience.js";

export type ListAudiencesResult = {
  /**
   * Audiences that can be assigned to plugins.
   */
  audiences: Array<PluginAudience>;
};

/** @internal */
export const ListAudiencesResult$inboundSchema: z.ZodMiniType<
  ListAudiencesResult,
  unknown
> = z.object({
  audiences: z.array(PluginAudience$inboundSchema),
});

export function listAudiencesResultFromJSON(
  jsonString: string,
): SafeParseResult<ListAudiencesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListAudiencesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListAudiencesResult' from JSON`,
  );
}
